export class FetchPodcastAction {
  public static readonly type = '[PodcastModel] Add item';

  constructor(public identifier: string) {}
}
